import base from "./base"
const tr = {
    ...base
}
export default tr
